import React from "react";
import { INK_3, LINE } from "../../Bureau/bureauTokens";

function formatDayLabel(date) {
  const d = new Date(date);
  if (isNaN(d)) return "";

  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  const sameDay = (a, b) => a.toDateString() === b.toDateString();

  if (sameDay(d, today)) return "Aujourd'hui";
  if (sameDay(d, yesterday)) return "Hier";
  return d.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "long",
    year: d.getFullYear() !== today.getFullYear() ? "numeric" : undefined,
  });
}

function DaySeparator({ date }) {
  return (
    <div className="flex items-center gap-3 my-3">
      <span className="flex-1" style={{ height: 1, background: LINE }} />
      <span className="text-[10.5px] font-semibold uppercase tracking-wide flex-shrink-0" style={{ color: INK_3 }}>
        {formatDayLabel(date)}
      </span>
      <span className="flex-1" style={{ height: 1, background: LINE }} />
    </div>
  );
}

export default DaySeparator;
